import { gender, salutation, quoteStatus, appIDDesc } from '@/const/underwriting'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'

export const globalMixin = {
  data: () => ({}),
  methods: {
    appDesc(appID) {
      return appIDDesc[appID]
    },
    formatDisplayDate(value) {
      return formatDisplayDate(value)
    },
    formatDisplayNumber(value) {
      return formatDisplayNumber(value)
    },
    formatGender(value) {
      return gender[value]
    },
    formatSalutation(value) {
      return salutation[value]
    },
    formatQuoteStatus(value) {
      return quoteStatus[value]
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      } else {
        return 'No'
      }
    }
  },
  computed: {
    quoteStatusList() {
      let result = []
      Object.keys(quoteStatus).forEach(function(key) {
        const status = quoteStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  }
}
